import { Tooltip, TooltipProps } from '@galaxy-react/core';
import { useEffect, useState } from 'react';

type Props = TooltipProps & {
  defaultVisible?: boolean;
  showToolTip?: boolean;
  children: React.ReactNode;
  relationship?: TooltipProps['relationship'];
  duration?: number;
};

const LRToolTip = (props: Props) => {
  const { defaultVisible, content, relationship, showToolTip = true, duration = 5000, ...restProps } = props;
  const [visible, setVisible] = useState<boolean>(defaultVisible ?? false);

  useEffect(() => {
    if (defaultVisible && duration) {
      setTimeout(() => {
        setVisible(false);
      }, duration);
    }
  }, [defaultVisible, duration]);
  if (!showToolTip) {
    return props.children;
  }

  return (
    <Tooltip
      visible={visible}
      onVisibleChange={(event, data) => setVisible(data.visible)}
      content={content}
      relationship={relationship ?? 'description'}
      {...restProps}
    >
      {props.children}
    </Tooltip>
  );
};

export default LRToolTip;
